<template>
  <div>
    <el-card shadow="never">
      <el-table :data="tableData">
        <el-table-column type="index" label="序号" align="center" width="50" />
        <el-table-column prop="twoCategoryName" label="二级类目" width="100" />
        <el-table-column prop="threeCategoryName" label="三级类目" width="150" />
        <el-table-column prop="categoryPackageNames" label="包装模板">
          <template slot-scope="scope">
            <div v-if="scope.row.categoryPackageNames && scope.row.categoryPackageNames.length > 0">
              <div v-for="item in scope.row.categoryPackageNames" :key="item.packageTemplateId">
                {{ item.packageTemplateName }}
              </div>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template #default="scope">
            <el-button type="text" size="small" @click="editItem(scope.row)" style="margin-right: 10px;">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="search.current" :page-size="search.size" layout="total, sizes, prev, pager, next"
        :total="totalNum" background />
    </el-card>

    <PackagingDialog ref="packagingDialog" @getList="getList()" />
  </div>
</template>


<script>
import uploadCover from '@/components/upload-cover/upload-cover.vue'
import PackagingDialog from './components/PackagingDialog.vue'
export default {
  components: {
    uploadCover,
    PackagingDialog
  },
  data() {
    return {
      dialogVisible: false,
      totalNum: 0,
      tableData: [],
      search: {
        current: 1,
        size: 20
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const res = await this.$request.post("/cms/category_packaget/get_category_list", this.search)
      if (res.data.code == 200) {
        this.tableData = res.data.data.records
        this.totalNum = res.data.data.total
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.search.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.search.current = val
      this.getList()
    },
    editItem(row) {
      this.$refs.packagingDialog.open(row.id)
    },
  }
}
</script>